var _circle, _circle2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59.25,
    stroke: "url(#paint0_linear_1074_600)",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.75 53.25C57.75 55.475 57.0902 57.6501 55.854 59.5002C54.6179 61.3502 52.8609 62.7922 50.8052 63.6436C48.7495 64.4951 46.4875 64.7179 44.3052 64.2838C42.123 63.8498 40.1184 62.7783 38.5451 61.205C36.9717 59.6316 35.9003 57.6271 35.4662 55.4448C35.0321 53.2625 35.2549 51.0005 36.1064 48.9448C36.9578 46.8891 38.3998 45.1321 40.2498 43.896C42.0999 42.6598 44.275 42 46.5 42C49.4837 42 52.3452 43.1853 54.455 45.295C56.5647 47.4048 57.75 50.2663 57.75 53.25Z",
    fill: "url(#paint1_linear_1074_600)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 46.4999C64.5 45.9032 64.7371 45.3309 65.159 44.909C65.581 44.487 66.1533 44.2499 66.75 44.2499H93.75C94.3467 44.2499 94.919 44.487 95.341 44.909C95.763 45.3309 96 45.9032 96 46.4999C96 47.0967 95.763 47.669 95.341 48.0909C94.919 48.5129 94.3467 48.7499 93.75 48.7499H66.75C66.1533 48.7499 65.581 48.5129 65.159 48.0909C64.7371 47.669 64.5 47.0967 64.5 46.4999ZM93.75 57.7499H66.75C66.1533 57.7499 65.581 57.987 65.159 58.409C64.7371 58.8309 64.5 59.4032 64.5 59.9999C64.5 60.5967 64.7371 61.169 65.159 61.5909C65.581 62.0129 66.1533 62.2499 66.75 62.2499H93.75C94.3467 62.2499 94.919 62.0129 95.341 61.5909C95.763 61.169 96 60.5967 96 59.9999C96 59.4032 95.763 58.8309 95.341 58.409C94.919 57.987 94.3467 57.7499 93.75 57.7499ZM93.75 71.2499H73.5C72.9033 71.2499 72.331 71.487 71.909 71.909C71.4871 72.3309 71.25 72.9032 71.25 73.4999C71.25 74.0967 71.4871 74.669 71.909 75.0909C72.331 75.5129 72.9033 75.7499 73.5 75.7499H93.75C94.3467 75.7499 94.919 75.5129 95.341 75.0909C95.763 74.669 96 74.0967 96 73.4999C96 72.9032 95.763 72.3309 95.341 71.909C94.919 71.487 94.3467 71.2499 93.75 71.2499ZM66.6797 77.4374C66.7533 77.7237 66.7697 78.0216 66.7281 78.3142C66.6865 78.6068 66.5876 78.8883 66.4372 79.1427C66.2867 79.3971 66.0877 79.6194 65.8513 79.7968C65.615 79.9742 65.346 80.1034 65.0597 80.1768C64.8763 80.2262 64.6871 80.2508 64.4972 80.2499C63.9982 80.2502 63.5132 80.0846 63.1187 79.7791C62.7241 79.4736 62.4423 79.0456 62.3175 78.5624C60.585 71.8293 53.7844 66.7499 46.4972 66.7499C39.21 66.7499 32.4094 71.8265 30.6769 78.5624C30.5277 79.1405 30.155 79.6357 29.6407 79.939C29.1265 80.2422 28.5128 80.3288 27.9347 80.1796C27.3566 80.0304 26.8615 79.6577 26.5582 79.1435C26.2549 78.6292 26.1683 78.0155 26.3175 77.4374C27.8897 71.3315 32.46 66.3871 38.2594 63.9374C36.0263 62.2175 34.3877 59.8417 33.5732 57.1433C32.7586 54.445 32.8092 51.5593 33.7176 48.8911C34.6261 46.2229 36.3469 43.9059 38.6388 42.2652C40.9306 40.6244 43.6786 39.7422 46.4972 39.7422C49.3158 39.7422 52.0638 40.6244 54.3556 42.2652C56.6475 43.9059 58.3683 46.2229 59.2768 48.8911C60.1852 51.5593 60.2358 54.445 59.4212 57.1433C58.6067 59.8417 56.968 62.2175 54.735 63.9374C60.5372 66.3871 65.1075 71.3315 66.6797 77.4374ZM46.5 62.2499C48.28 62.2499 50.0201 61.7221 51.5001 60.7332C52.9802 59.7442 54.1337 58.3386 54.8149 56.6941C55.4961 55.0496 55.6743 53.24 55.3271 51.4941C54.9798 49.7483 54.1226 48.1447 52.864 46.886C51.6053 45.6273 50.0017 44.7701 48.2558 44.4229C46.51 44.0756 44.7004 44.2538 43.0559 44.935C41.4113 45.6162 40.0057 46.7698 39.0168 48.2498C38.0279 49.7299 37.5 51.4699 37.5 53.2499C37.5 55.6369 38.4482 57.9261 40.136 59.6139C41.8239 61.3017 44.1131 62.2499 46.5 62.2499Z",
    fill: "url(#paint2_linear_1074_600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_600",
    x1: 0,
    y1: 120,
    x2: 90.5973,
    y2: 89.6441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1074_600",
    x1: 35.25,
    y1: 64.5,
    x2: 52.237,
    y2: 58.8083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1074_600",
    x1: 26.2461,
    y1: 80.251,
    x2: 70.1921,
    y2: 54.8959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.a26df18bf78f2dcfdf26b9ef0358a73a.svg";
export { ForwardRef as ReactComponent };